var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { BButton, BCard, BFormGroup, BFormInput, BFormRadio, BFormRadioGroup } from "bootstrap-vue";
import { computed, ref } from "vue";
import { createRemoteEntry } from "@/api/remoteFiles";
import { useToast } from "@/composables/toast";
import localize from "@/utils/localization";
import { errorMessageAsString } from "@/utils/simple-error";
import ExternalLink from "@/components/ExternalLink.vue";
import FilesInput from "@/components/FilesDialog/FilesInput.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExportRDMForm',
    props: {
        what: { default: "archive" },
        clearInputAfterExport: { type: Boolean, default: false },
        defaultRecordName: { default: "" },
        defaultFilename: { default: "" }
    },
    emits: ["export"],
    setup(__props, { emit }) {
        const props = __props;
        const toast = useToast();
        const includeOnlyRDMCompatible = { include: ["rdm"] };
        const recordUri = ref("");
        const sourceUri = ref("");
        const fileName = ref(props.defaultFilename);
        const exportChoice = ref("new");
        const recordName = ref(props.defaultRecordName);
        const newEntry = ref();
        const canCreateRecord = computed(() => Boolean(sourceUri.value) && Boolean(recordName.value));
        const canExport = computed(() => Boolean(recordUri.value) && Boolean(fileName.value));
        const repositoryRecordDescription = computed(() => localize(`Select a repository to export ${props.what} to.`));
        const nameDescription = computed(() => localize("Give the exported file a name."));
        const recordNameDescription = computed(() => localize("Give the new record a name or title."));
        const namePlaceholder = computed(() => localize("File name"));
        const recordNamePlaceholder = computed(() => localize("Record name"));
        function doExport() {
            emit("export", recordUri.value, fileName.value);
            if (props.clearInputAfterExport) {
                clearInputs();
            }
        }
        function doCreateRecord() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    newEntry.value = yield createRemoteEntry(sourceUri.value, recordName.value);
                    recordUri.value = newEntry.value.uri;
                }
                catch (e) {
                    toast.error(errorMessageAsString(e));
                }
            });
        }
        function clearInputs() {
            recordUri.value = "";
            sourceUri.value = "";
            fileName.value = "";
            newEntry.value = undefined;
        }
        return { __sfc: true, toast, props, emit, includeOnlyRDMCompatible, recordUri, sourceUri, fileName, exportChoice, recordName, newEntry, canCreateRecord, canExport, repositoryRecordDescription, nameDescription, recordNameDescription, namePlaceholder, recordNamePlaceholder, doExport, doCreateRecord, clearInputs, BButton, BCard, BFormGroup, BFormInput, BFormRadio, BFormRadioGroup, ExternalLink, FilesInput };
    }
});
